// Arabic Locale data from https://github.com/moment/moment/blob/develop/locale/ar.js

export const WEEKDAYS_LONG = {
  eng: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
  ara: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
  hin: 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
  en: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
  ar: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
  hi: 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
};
export const WEEKDAYS_SHORT = {
  eng: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  ara: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
  hin: 'रवि_सोम_मंगल_बुध_गुरु_शुक्र_शनि'.split('_'),
  en: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  ar: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
  hi: 'रवि_सोम_मंगल_बुध_गुरु_शुक्र_शनि'.split('_'),
};
export const MONTHS = {
  eng: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
  ara: ['يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو', 'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر'],
  hin: 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
  en: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
  ar: ['يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو', 'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر'],
  hi: 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
};

export const MONTHS_SHORT = {
  eng: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  hin: ['जन॰', 'फर॰', 'मार्च', 'अप्रैल', 'मई', 'जून', 'जुल॰', 'अग॰', 'सित॰', 'अक्टू॰', 'नव॰', 'दिस॰'],
  en: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  hi: ['जन॰', 'फर॰', 'मार्च', 'अप्रैल', 'मई', 'जून', 'जुल॰', 'अग॰', 'सित॰', 'अक्टू॰', 'नव॰', 'दिस॰'],
};

export const HINDI_MONTHS = {
  Jan: 'जन॰',
  Feb: 'फर॰',
  Mar: 'मार्च',
  Apr: 'अप्रैल',
  May: 'मई',
  Jun: 'जून',
  Jul: 'जुल॰',
  Aug: 'अग॰',
  Sep: 'सित॰',
  Oct: 'अक्टू॰',
  Nov: 'नव॰',
  Dec: 'दिस॰',
};

export const FIRST_DAY = {
  eng: 0,
  ara: 6, // Use Saturday as first day of the week
  hin: 0,
  en: 0,
  ar: 6, // Use Saturday as first day of the week
  hi: 0,
};

const getLang = (lang) => {
  if (lang.length > 0) {
    return lang;
  }
  return 'eng';
};

function formatDay(d, locale = 'eng') {
  locale = getLang(locale);
  return `${WEEKDAYS_LONG?.[locale][d?.getDay()]}, ${d?.getDate()} ${MONTHS?.[locale][d?.getMonth()]} ${d.getFullYear()}`;
}

function formatMonthTitle(d, locale = 'eng') {
  locale = getLang(locale);
  return `${MONTHS[locale][d.getMonth()]} ${d.getFullYear()}`;
}

function formatWeekdayShort(i, locale = 'eng') {
  locale = getLang(locale);
  return WEEKDAYS_SHORT[locale][i];
}

function formatWeekdayLong(i, locale = 'eng') {
  locale = getLang(locale);
  return WEEKDAYS_SHORT[locale][i];
}

function getFirstDayOfWeek(locale = 'eng') {
  locale = getLang(locale);
  return FIRST_DAY[locale];
}

const localeUtils = {
  formatDay,
  formatMonthTitle,
  formatWeekdayShort,
  formatWeekdayLong,
  getFirstDayOfWeek,
};

export default localeUtils;
